import { inject } from '@angular/core';
import { CanActivateFn, Router, Routes } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { DataPersistenceService } from '../services/data-persistence/data-persistence.service';
import { CONTEXTO_PROVEEDOR, ContextoProveedor, CredencialesProveedor } from './portal-proveedor';
import { MiFichaComponent, MisRegistrosComponent, MisTareasProveedorComponent } from './proveedor.components';

function leer(persistencia: DataPersistenceService, cookies: CookieService): CredencialesProveedor | null {
  const token = persistencia.getAccessToken(), tokenPermisos = cookies.get('tokenPermisos');
  return token && tokenPermisos ? { token, tokenPermisos } : null;
}

/** Exige la sesión del proveedor (token de Cognito + tokenPermisos). La API vuelve a validar ambos. */
export const proveedorGuard: CanActivateFn = () => leer(inject(DataPersistenceService), inject(CookieService)) !== null || inject(Router).parseUrl('/unauthorized');

export const proveedorRoutes: Routes = [{
  path: 'proveedor',
  canActivate: [proveedorGuard],
  providers: [{
    provide: CONTEXTO_PROVEEDOR,
    useFactory: (): ContextoProveedor => {
      const persistencia = inject(DataPersistenceService), cookies = inject(CookieService), router = inject(Router);
      return {
        credenciales: () => leer(persistencia, cookies),
        navegar: ruta => void router.navigateByUrl(ruta),
      };
    },
  }],
  children: [
    { path: '', component: MisRegistrosComponent, title: 'Mis registros' },
    { path: 'tareas', component: MisTareasProveedorComponent, title: 'Mis tareas' },
    { path: 'clientes/:clienteId', component: MiFichaComponent, title: 'Mi ficha' },
  ],
}];
